import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c9819e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("流水")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("发票")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("订单")
const _hoisted_4 = { key: 1 }

import {ref, computed, onMounted} from 'vue'
import { formatNumber, getNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    balanceId: null
  },
  setup(__props: any) {

const props = __props as {
  balanceId: number
}

const {
  // 勾销记录对应的流水发票
  'GET/verification/translation/balance_list/{id}': balanceId,
} = Api


const isLoading = ref<booelan>(false)

const custData = ref([])
const InvDate = ref([])
const orderDate = ref([])




onMounted(() => {
  isLoading.value = true
  balanceId({id: props.balanceId}).then((rep: any) => {
    custData.value = rep.flows
    InvDate.value = rep.invoices
    orderDate.value = rep.orders
  }).finally(() => {
    isLoading.value = false
  })
})


const tableHeight = computed(() => {
  return window.innerHeight - 210
})

const isShowDiff = ref(false)
const rowTitle = ref('')
let diffData = ref([])
const showDiffHandle = (row: any) => {
  rowTitle.value = row.no
  diffData.value = row.updateRecords
  isShowDiff.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_table, {
              data: custData.value,
              ref: "cutTable",
              "row-key": "id",
              border: "",
              "max-height": _unref(tableHeight) / 2.2 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "收付方名称",
                  prop: "costTo",
                  width: "120",
                  "show-overflow-tooltip": "",
                  fixed: ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(row.costTo), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "ID",
                  prop: "id",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "匹配客户",
                  prop: "matchCustomers",
                  width: "105",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "收款币别",
                  prop: "receiptCurrency",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "收款金额",
                  prop: "receiptAmount",
                  width: "115",
                  align: "right",
                  formatter: _unref(formatNumber),
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "本位币",
                  prop: "standardMoney",
                  width: "115",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": "",
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "回款日期",
                  prop: "collectionAt",
                  width: "115",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "公司名称",
                  prop: "costFrom",
                  width: "230",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "账户简称",
                  prop: "accountName",
                  width: "135",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  prop: "currency"
                }),
                _createVNode(_component_el_table_column, {
                  label: "借方",
                  prop: "costOut",
                  align: "right",
                  width: "100",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "贷方",
                  prop: "costIn",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "手续费",
                  prop: "handlingFee",
                  align: "right",
                  width: "100",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "银行摘要",
                  prop: "summary",
                  width: "200",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "款项类型",
                  prop: "paymentType",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "备注",
                  prop: "remarks",
                  width: "130",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "匹配核销备注",
                  prop: "matchRemarks",
                  width: "130",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "团队",
                  prop: "team",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "销售",
                  prop: "saler",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "匹配状态",
                  width: "115",
                  prop: "matchStatus"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.matchStatus === 'Matched' ? '已匹配' : '未匹配'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "勾销状态",
                  width: "115",
                  prop: "verifyStatus"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.verifyStatus === null ? '未勾销' : row.verifyStatus === 'Verified' ? '已勾销' : '部分勾销'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "status"
                }),
                _createVNode(_component_el_table_column, {
                  label: "导入批次",
                  prop: "fileId",
                  width: "150"
                }),
                _createVNode(_component_el_table_column, {
                  label: "账户ID",
                  prop: "accountNumber",
                  "show-overflow-tooltip": ""
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_table, {
              ref: "invTable",
              border: "",
              data: InvDate.value,
              "row-key": "index",
              "max-height": _unref(tableHeight) / 2.2 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "境内外",
                  prop: "domestic",
                  fixed: "",
                  width: "100",
                  "show-overflow-tooltip": "",
                  formatter: (row) => row.domestic ? '境内' : '境外'
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "客户名称",
                  prop: "client",
                  fixed: "",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票编号",
                  prop: "no",
                  width: "140",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  prop: "currency"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  prop: "invoiceAmount",
                  align: "right",
                  width: "100",
                  formatter: _unref(formatNumber),
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "本位币",
                  prop: "standardMoney",
                  width: "105",
                  align: "right",
                  formatter: _unref(formatNumber),
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "发票日期",
                  prop: "invoiceDate",
                  width: "105",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  formatter: _unref(formatTime)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "税率",
                  prop: "taxRate",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "来源",
                  prop: "source",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户ID",
                  prop: "clientUsername",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "销售名称",
                  prop: "saler",
                  "show-overflow-tooltip": "",
                  width: "100"
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 20,
      class: "mt-20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_table, {
              data: orderDate.value,
              border: "",
              "row-class-name": ({row}) => row.updateAmountFlag === true ? 'warning-row ': '',
              "row-key": "id",
              "max-height": _unref(tableHeight) / 2.2 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  width: "125",
                  label: "订单编号(双击)",
                  prop: "no",
                  "show-overflow-tooltip": "",
                  fixed: ""
                }, {
                  default: _withCtx(({row}) => [
                    (row.updateAmountFlag === true)
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "primary",
                          onDblclick: ($event: any) => (showDiffHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.no), 1)
                          ]),
                          _: 2
                        }, 1032, ["onDblclick"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.no), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户名称",
                  prop: "customer",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币种",
                  prop: "currency",
                  width: "65"
                }),
                _createVNode(_component_el_table_column, {
                  label: "金额",
                  prop: "amount",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": "",
                  width: "125"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "完工时间",
                  prop: "deliverTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "100",
                  label: "发票编号",
                  prop: "invoiceNo",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户ID",
                  prop: "customerUsername",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "境内外",
                  prop: "domestic",
                  "show-overflow-tooltip": "",
                  formatter: (row) => row.domestic === true ? '境内' : '境外'
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "发票主体",
                  prop: "invoiceCompany",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "回款公司",
                  prop: "flowCompany",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "订单名称",
                  prop: "name",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "po号",
                  prop: "poNumber",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "本位币",
                  prop: "standardMoney",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "USD金额",
                  prop: "baseCurrencyMoney",
                  align: "right"
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(parseFloat(row.baseCurrencyMoney))), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "status",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "客户经理",
                  prop: "owner",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "开始时间",
                  prop: "startTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "确认完工时间",
                  prop: "confirmDeliverTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "关单时间",
                  prop: "closeTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "确认关单时间",
                  prop: "confirmCloseTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "回款时间",
                  prop: "financialTime",
                  formatter: _unref(formatTime),
                  width: "120",
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "核销时间",
                  prop: "verifyTime",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "手续费",
                  prop: "feeCo3",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "财务费用",
                  prop: "financialExpenses",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "105",
                  label: "坏账",
                  prop: "badDebt",
                  align: "right",
                  formatter: _unref(formatNumber),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data", "row-class-name", "max-height"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: rowTitle.value + '金额差异',
      modelValue: isShowDiff.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowDiff).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(diffData)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "原始USD金额",
              prop: "originalBaseCurrencyMoney",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "修改后USD金额",
              prop: "updateBaseCurrencyMoney",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "原始金额",
              prop: "originalAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "原始币种",
              prop: "originalCurrency",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "修改后金额",
              prop: "updateAmount",
              "show-overflow-tooltip": "",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "修改后币种",
              prop: "updateCurrency",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})